import { BrowserRouter as Router } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AuthContextProvider from "./Contexts/AuthContext";
import CalcContextProvider from "./Contexts/CalcContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <AuthContextProvider>
      <CalcContextProvider>
        <App />
      </CalcContextProvider>
    </AuthContextProvider>
  </Router>
);
